// URLs of the Schedules table and the schedule builder, and the builder's
// lazy chunk. Shared so the table links into the builder, and starts loading
// it on intent, without importing it.
export const SCHEDULES_PATH = '/dashboard/prepacks/automations/schedules'
/** Templates (the Configuration page): the card templates the builder links to (its settings cards removed in #1045). */
export const CONFIGURATION_PATH = '/dashboard/prepacks/configuration'
/** Surfaces: where a surface is turned on or off, which the builder's Surfaces list links to. */
export const SURFACES_PATH = '/dashboard/prepacks/surfaces'

/** A new schedule, optionally copied from `duplicateId`. */
export const newSchedulePath = (duplicateId) => (duplicateId
  ? `${SCHEDULES_PATH}/new?duplicate=${encodeURIComponent(duplicateId)}`
  : `${SCHEDULES_PATH}/new`)

/** An existing schedule's page; read-only for operators without configure access. */
export const schedulePath = (id) => `${SCHEDULES_PATH}/${encodeURIComponent(id)}`

/** The Packs card at the bottom of a saved schedule's page (#1080), scrolled into view once its list loads. */
export const SCHEDULE_PACKS_ID = 'packs'
export const schedulePacksPath = (id) => `${schedulePath(id)}#${SCHEDULE_PACKS_ID}`

/**
 * Schedules → Unscheduled packs (#1080): the packs no live schedule made,
 * drafts saved from Create and packs whose schedule was deleted. The list
 * asks the server for them with this recipe value.
 */
export const UNSCHEDULED_PACKS_PATH = '/dashboard/prepacks/automations/unscheduled'
export const UNSCHEDULED_RECIPE = 'none'

/** Loads the builder page's chunk; `lazy` uses it, and the table calls it on hover or focus. */
export const loadScheduleBuilder = () => import('./PrepackScheduleBuilderPage')

/**
 * Starts loading the builder on intent (hover or focus). A failed preload is
 * ignored here: the navigation that needs the chunk loads it again and shows
 * the error.
 */
export const preloadScheduleBuilder = () => {
  loadScheduleBuilder().catch(() => {})
}
